import type { ReactNode, CSSProperties } from 'react';
import './Text.css';

interface TextProps {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  as?: keyof HTMLElementTagNameMap;
}

/** Large display title — Lilita One, golden stroke, 3D shadow */
export function Title({ children, className, style, as: Tag = 'h1' }: TextProps) {
  return <Tag className={`ui-title title-warm ${className ?? ''}`.trim()} style={style}>{children}</Tag>;
}

/** Section heading — Lilita One, smaller, dark brown */
export function Heading({ children, className, style, as: Tag = 'h2' }: TextProps) {
  return <Tag className={`ui-heading ${className ?? ''}`.trim()} style={style}>{children}</Tag>;
}

/** Subtitle text — medium brown, semi-bold */
export function Subtitle({ children, className, style, as: Tag = 'p' }: TextProps) {
  return <Tag className={`ui-subtitle ${className ?? ''}`.trim()} style={style}>{children}</Tag>;
}

/** Body text — standard readable text */
export function Body({ children, className, style, as: Tag = 'p' }: TextProps) {
  return <Tag className={`ui-body ${className ?? ''}`.trim()} style={style}>{children}</Tag>;
}

/** Small muted text — lighter, less prominent */
export function Muted({ children, className, style, as: Tag = 'span' }: TextProps) {
  return <Tag className={`ui-muted ${className ?? ''}`.trim()} style={style}>{children}</Tag>;
}

/** Bold label — used for form labels, chips, badges */
export function Label({ children, className, style, as: Tag = 'span' }: TextProps) {
  return <Tag className={`ui-label ${className ?? ''}`.trim()} style={style}>{children}</Tag>;
}

/** Tiny caption — smallest text, used for metadata */
export function Caption({ children, className, style, as: Tag = 'span' }: TextProps) {
  return <Tag className={`ui-caption ${className ?? ''}`.trim()} style={style}>{children}</Tag>;
}
